import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Labels from './Labels';
import Columns from './Columns';
import Image from '../../../../Image';
import { transformPrompt } from '../../../../../utils';

export default function BipolarVertical({ rows, labels }) {
  return (
    <div className="answers">
      {rows.map((row, index) => (
        <Fragment>
          <div
            id={row.id}
            className="answer--bipolar bipolar-vertical"
            data-row-order={index}
            data-testid="matrix-row"
          >
            <div className="bipolar-vertical-row-labels bipolar-vertical-row-labels--top">
              <span
                className="bipolar-vertical-row-label inline-children"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html:
                    transformPrompt(row.rowLabels.beforeLabel) || '&nbsp;',
                }}
              />
            </div>
            <div className="bipolar-vertical-content">
              <Image row={row.beforeImage} />
              <div className="flex bipolar-vertical-wrapper">
                <Labels labels={labels} />
                <Columns columns={row.columns} />
                <div className="flex-1"></div>
              </div>
            </div>
            <div className="bipolar-vertical-row-labels bipolar-vertical-row-labels--bottom">
              <span
                className="bipolar-vertical-row-label inline-children"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: transformPrompt(row.rowLabels.afterLabel) || '&nbsp;',
                }}
              ></span>
            </div>
            <div className="bipolar-vertical-after-image">
              <Image row={row.afterImage} />
            </div>
          </div>
          <div className="divider margin-lg"></div>
        </Fragment>
      ))}
    </div>
  );
}

BipolarVertical.propTypes = {
  rows: PropTypes.array,
  labels: PropTypes.array,
};
